import React, { Component } from "react";
import AssistantDirectionOutlinedIcon from "@mui/icons-material/AssistantDirectionOutlined";
import IconButton from "@material-ui/core/IconButton";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";

export default class StoreInfo extends Component {
  render() {""
    return (
      <div className={this.props.cssClass}>
        <h4 style={{fontFamily:'Noto Sans' }}>{this.props.cusName}</h4>
        <div style={{ width: "100%", fontSize: "12px", display: "flex", fontFamily:'Noto Sans' }}>
          <div style={{ fontSize: "12px", width:'80%', fontWeight:'500' }}>{this.props.addr1}</div>
          <div
            style={{
              marginTop: "5px",
              display: "flex",

              fontSize: "92%",
            }}
          >
           
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                textAlign: "center",
                marginRight: "11px",
                marginLeft: "5px",
              }}
            >
              <IconButton
                style={{ padding: "0px" }}
                onClick={() =>
                  window.open(
                    "https://www.google.com/maps/dir/" +
                      this.props.currentlocationData.lat +
                      "," +
                      this.props.currentlocationData.lng +
                      "/" +
                      this.props.latlng.lat +
                      "," +
                      this.props.latlng.lng,
                    "_blank"
                  )
                }
              >
                <AssistantDirectionOutlinedIcon color="primary" />
              </IconButton>
              <span>Directions</span>
            </div>
            {this.props.shopLink ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  textAlign: "center",
                }}
              >
                <IconButton color="primary" style={{ padding: "0px" }} onClick={() =>
                  window.open(
                    `${this.props.shopLink}`,
                    "_blank"
                  )
                }>
                  <LocalMallOutlinedIcon color="primary" />
                </IconButton>
                <span>Shop</span>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>

        <a
          href={`tel:+ ${this.props.phoneNum}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {`+${this.props.phoneNum}`} 
        </a>
        <br />
        {
          this.props.phoneNum2 ? 
          <a
          href={`tel:+ ${this.props.phoneNum2}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {`+${this.props.phoneNum2}`} 
        </a>
        : ''
        }

      </div>
    );
  }
}
